import { LayoutDashboard, User, Users, GraduationCap, Wallet, CreditCard, FileBarChart, CalendarCheck, AlertCircle, KeyRound, Database, ScrollText, ClipboardList, BookOpen, BookMarked, MessagesSquare, FileText, Bell, MessageCircle, Phone, HandHelping, FolderOpen, ClipboardCheck, Briefcase } from "lucide-react";

export const MENUS = {
  admin: [
    { to: "/dashboard", label: "Dashboard", icon: LayoutDashboard },
    { to: "/profil", label: "Profil Admin", icon: User },
    { to: "/profil-koordinator", label: "Profil Koordinator", icon: User },
    { to: "/siswa", label: "Data Siswa", icon: GraduationCap },
    { to: "/guru", label: "Data Guru", icon: Users },
    { to: "/gaji", label: "Data Gaji", icon: Wallet },
    { to: "/spp", label: "SPP Pendampingan", icon: CreditCard },
    { to: "/keuangan", label: "Laporan Keuangan", icon: FileBarChart },
    { to: "/absensi-guru", label: "Absensi Guru", icon: CalendarCheck },
    { to: "/kendala", label: "Kendala", icon: AlertCircle },
    { to: "/users", label: "Manajemen User", icon: KeyRound },
    { to: "/backup", label: "Database & Backup", icon: Database },
    { to: "/log", label: "Log Aktivitas", icon: ScrollText },
  ],
  koordinator: [
    { to: "/dashboard", label: "Dashboard", icon: LayoutDashboard },
    { to: "/profil", label: "Profil", icon: User },
    { label: "Data", icon: FolderOpen, children: [{ to: "/siswa", label: "Data Siswa" }, { to: "/guru", label: "Data Guru" }] },
    { label: "Administrasi", icon: Briefcase, children: [{ to: "/gaji", label: "Data Gaji" }, { to: "/spp", label: "SPP Pendampingan" }, { to: "/keuangan", label: "Laporan Keuangan" }, { to: "/izin-guru", label: "Izin Guru" }] },
    { label: "Dokumen", icon: FileText, children: [{ to: "/pendampingan", label: "Pendampingan" }, { to: "/buku-batas", label: "Buku Batas" }, { to: "/absensi-siswa", label: "Absensi Siswa" }, { to: "/absensi-guru", label: "Absensi Guru" }, { to: "/buku-penghubung", label: "Buku Penghubung" }, { to: "/laporan", label: "Laporan" }, { to: "/program-kekhususan", label: "Program Kekhususan" }] },
    { to: "/kendala", label: "Kendala", icon: AlertCircle },
    { to: "/pemberitahuan", label: "Pemberitahuan", icon: Bell },
    { to: "/saran", label: "Saran & Kritik", icon: MessageCircle },
  ],
  guru: [
    { to: "/dashboard", label: "Dashboard", icon: LayoutDashboard },
    { label: "Profil", icon: User, children: [{ to: "/profil-guru", label: "Profil Guru" }, { to: "/profil-siswa", label: "Profil Siswa" }] },
    { label: "Dokumen", icon: FileText, children: [{ to: "/buku-batas", label: "Buku Batas" }, { to: "/buku-penghubung", label: "Buku Penghubung" }, { to: "/laporan", label: "Laporan" }, { to: "/program-kekhususan", label: "Program Kekhususan" }] },
    { label: "Absen", icon: ClipboardCheck, children: [{ to: "/absensi-siswa", label: "Absen Siswa" }, { to: "/absensi-guru", label: "Absensi Guru" }, { to: "/izin-guru", label: "Izin Guru" }] },
    { to: "/gaji", label: "Data Gaji", icon: Wallet },
    { to: "/pemberitahuan", label: "Pemberitahuan", icon: Bell },
    { to: "/kendala", label: "Kendala", icon: AlertCircle },
  ],
  ortu: [
    { to: "/dashboard", label: "Dashboard", icon: LayoutDashboard },
    { to: "/profil-siswa", label: "Profil Siswa", icon: GraduationCap },
    { to: "/profil-guru", label: "Profil Guru", icon: User },
    { label: "Absensi", icon: CalendarCheck, children: [{ to: "/absensi-siswa", label: "Absen Siswa" }, { to: "/absensi-guru", label: "Absen Guru" }] },
    { to: "/buku-penghubung", label: "Buku Penghubung", icon: BookOpen },
    { to: "/laporan", label: "Laporan", icon: ClipboardList },
    { to: "/program-kekhususan", label: "Program Kekhususan", icon: BookMarked },
    { to: "/pemberitahuan", label: "Pemberitahuan", icon: Bell },
    { to: "/saran", label: "Saran & Kritik", icon: MessageCircle },
    { to: "/hubungi-kami", label: "Hubungi Kami", icon: Phone },
  ],
};
export const ICONS = { BookMarked, MessagesSquare, HandHelping };
